import { isSameDay } from 'date-fns';
import { toZeroTime } from 'helpers';

export const calculateBusinessDays = (
  startDate: Date,
  endDate: Date,
  disabledDates: Date[]
): number => {
  let count = 0;

  const startDateZeroTime = toZeroTime(new Date(startDate.getTime()));
  const endDateZeroTime = toZeroTime(new Date(endDate.getTime()));
  const enabledYears = new Set(disabledDates.map((date) => date.getFullYear()));

  while (startDateZeroTime <= endDateZeroTime) {
    if (!disabledDates.some((d) => isSameDay(startDateZeroTime, d))) {
      // If calendar is not configured for a year, all days of that year are considered non-working
      if (enabledYears.has(startDateZeroTime.getFullYear())) {
        count += 1;
      }
    }
    // Move to the next day
    startDateZeroTime.setDate(startDateZeroTime.getDate() + 1);
  }

  return count;
};
